/**
 * Menu
 */
export default {
    m: {
        Home: 'Home',
        Dashboard: 'Dashboard',
        Users: 'Users',
        Users_Users: 'Users',
        Users_Overview: 'Overview',
        Dashboard_Features_Overview: 'Features',

        'Financial-Management': 'Financial Management',
        'Financial-Management_Capital-Operation-Records': 'Capital Operation Records',

        'System-Management': 'System Management',
        'System-Management_Accounts': 'Accounts',
        'System-Management_Roles': 'Roles',
        'System-Management_System-Logs': 'Logs',
        'System-Management_Exports': 'Downloads',

        'Service-Config_Service-Config': 'Service Config',

        'Client-Management': 'Client Config',
        'Client-Management_App-Version-Updates': 'App Version Config',
        'Client-Management_Content-Filter': 'Content Filter',
        'Client-Management_Banner': 'Banner Config',

        Dramas: 'Dramas',
        Dramas_Dramas: 'Drama List',
        Dramas_Reports: 'Reports',
        Dramas_Reports_Content: 'Content reports',
        Dramas_Reports_Users: 'User reports',
        Dramas_Reports_Comments: 'Comment reports',
        Dramas_Comments: 'Comment List',
        'Dramas_Mining-Weekly-Rewards': 'Mining Settlements',
        'Dramas_Activity-1011': '1011 Activity',
        'Dramas_Activity-1011_Share-Review': 'Share Review',
        'Dramas_Activity-1011_User-Stories': 'Story Collection',
        'Dramas_Activity-1011_Task-Config': 'Task Config',
    },
};
